import React from 'react';
import { Phone, Mail } from 'lucide-react';
export function ContactInfoSection() {
  return <div data-id="element-209">
      <h2 className="text-3xl font-bold text-brand-dark mb-8" data-id="element-210">
        We're Here To Help
      </h2>
      <p className="text-gray-600 mb-10 text-lg" data-id="element-211">
        Have questions about the ForceX system? Need a custom quote for your
        fleet? Our team of industry experts is ready to assist you.
      </p>

      <div className="space-y-8" data-id="element-212">
        <div className="flex items-start" data-id="element-213">
          <div className="bg-brand-yellow/10 p-3 rounded-full mr-4" data-id="element-214">
            <Phone className="h-6 w-6 text-brand-yellow" data-id="element-215" />
          </div>
          <div data-id="element-216">
            <h3 className="font-bold text-brand-dark text-lg" data-id="element-217">Phone</h3>
            <p className="text-gray-600 mb-1" data-id="element-218">Mon-Fri from 8am to 5pm EST</p>
            <a href="tel:8108185941" className="text-xl font-bold text-brand-yellow hover:text-yellow-600" data-id="element-219">
              810-818-5941
            </a>
          </div>
        </div>

        <div className="flex items-start" data-id="element-220">
          <div className="bg-brand-yellow/10 p-3 rounded-full mr-4" data-id="element-221">
            <Mail className="h-6 w-6 text-brand-yellow" data-id="element-222" />
          </div>
          <div data-id="element-223">
            <h3 className="font-bold text-brand-dark text-lg" data-id="element-224">Email</h3>
            <p className="text-gray-600 mb-1" data-id="element-225">
              For sales and support inquiries
            </p>
            <a href="mailto:brandon@precisionprosprayers.com" className="text-xl font-bold text-brand-yellow hover:text-yellow-600" data-id="element-226">
              brandon@precisionprosprayers.com
            </a>
          </div>
        </div>
      </div>
    </div>;
}